import axios from './axios';

/**
 * @param {string} studentId
 * @param {string} date
 */
export const getAgendaList = (studentId, date) => axios.get(`/pupils/${studentId}/agenda/${date}`);

/**
 * @param {string} studentId
 * @param {string} date
 * @param {string} routeId
 */
export const getAgendaDetails = (studentId, date, routeId) =>
  axios.get(`/pupils/${studentId}/agenda/${date}/routes/${routeId}`);
